import "./css/modern-normalize.css";
import "./css/main-style.css";
import images from "/src/js/images.js";
import { fetchWeatherData } from "./js/data";
import {
    changeBg,
    createGif,
    displaySearchBar,
    displayWeather,
    listenElements,
    showError,
} from "./js/UI";

displaySearchBar();

const { input, inputButton } = listenElements();

async function getWeatherData( location ) {
    const gifDiv = createGif();
    const data = await fetchWeatherData( location );
    gifDiv.remove();
    if ( data ) {
        displayWeather( data );
        changeBg( data.icon );
    }
    input.value = "";
}

function validateLocation( input ) {
    if ( !input.value ) {
        showError( "It's not gonna work without data 🤷" );
        return false;
    }

    getWeatherData( input.value.trim() );
    return true;
}

( () => {
    inputButton.addEventListener( "click", () => validateLocation( input ) );
    input.addEventListener( "keydown", ( e ) => {
        if ( e.key === "Enter" ) {
            if ( validateLocation( input ) ) e.target.blur();;
        }
    } );
} )();
